import React, { Component } from 'react';
import { Card, Button, Form, Row, Col, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../../Helpers/fetcher.js";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { Notify } from "../../../Helpers/notification.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import { Redirect } from "react-router-dom";

class ReportScheduling extends Component {

    constructor(props) {
        super(props);
        this.state = {
            reportScheduleList: [],
            apiPath: props.app.apiPath,
            role: props.app.role,
            userId: props.app.userId,
            noDataDisplayMsg: '',
            sizePerPage: 10,
            addReportScheduleModel: false,
            reportParamsList:[],
            selectedReportParams:[],
            selectedFrequency:'',
            loggedInUser:'',
            isEdit: false,
            isEnable: false,
            scheduleId: '',
            loading: true,
        }
        document.title = 'Report Scheduling'

    }

    componentDidMount() {
        const savedSizePerPage = 10
        if (savedSizePerPage) {
            this.setState({ sizePerPage: Number(savedSizePerPage) });
        }
        const apiPath = this.props.app.apiPath;
        Fetcher.get(apiPath + '/api/obd/user/profile/' + this.props.app.userId,)
            .then(res => {
                this.setState({
                    loggedInUser: res,
                })
            })
            .catch(err => { console.log('Error in fetching Users data', err) });

        // get schedule list
        this.getScheduleList()    
        
    }

    setvalue = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }


    handleSizePerPageChange = (newSizePerPage) => {
        this.setState({ sizePerPage: newSizePerPage });
        Cookies.set('callDetailRecordListsizePerPage', newSizePerPage);
    }

    getScheduleList = () => {
        const apiPath = this.props.app.apiPath;

        this.setState({ loading: true });
        Fetcher.get(apiPath + '/api/obd/report/schedule/' + this.props.app.userId,)
            .then(res => {
                this.setState({
                    reportScheduleList: res,
                    loading: false,
                })
            })
            .catch(err => { console.log('Error in fetching Schedule List', err); this.setState({ loading: false }); });
    }

    getReportParameters = () => {
        const apiPath = this.props.app.apiPath;

        Fetcher.get(apiPath+ '/api/obd/report_parameters')
            .then(res => {
                this.setState({
                    reportParamsList: res,
                })
            })
            .catch(err => { console.log('Error in fetching Report Parameter List', err) });
    }

    addReportSchedule = () => {
        this.getReportParameters()
        this.setState({ addReportScheduleModel: true });
    }

    closeModal = () => {
        this.setState({ addReportScheduleModel: false , isEdit: false, selectedFrequency: '', selectedReportParams: [], isEnable: false});
    };

    toggleParam = (paramName) => {
        this.setState(prevState => {
            const selected = prevState.selectedReportParams.includes(paramName)
                ? prevState.selectedReportParams.filter(p => p !== paramName)
                : [...prevState.selectedReportParams, paramName];

            return { selectedReportParams: selected };
        });
    };


    toggleSelectAll = () => {
        const { reportParamsList, selectedReportParams } = this.state;

        if (selectedReportParams.length === reportParamsList.length) {
            // Unselect all
            this.setState({ selectedReportParams: [] });
        } else {
            // Select all
            this.setState({
                selectedReportParams: reportParamsList.map(p => p.paramName)
            });
        }
    };


    createReportScheduling = () => {
       if (this.state.selectedReportParams.length <= 0) {
          Notify.notify('Please Select Report Parameteres.')
          return
       }
       if (this.state.selectedFrequency == '') {
          Notify.notify('Please Select Frequency.')
          return
       }

       const params = {
        userId : this.props.app.userId,
        email:this.state.loggedInUser?.emailid,
        frequency: this.state.selectedFrequency,
        enable: true,
        status: 'IDLE',
        timezone: 'Asia/Kolkata',
        parameterJson: this.state.selectedReportParams.join(',')
       }

        return Fetcher.post(this.props.app.apiPath + '/api/obd/report/schedule', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(params) })
            .then(res => {
                Notify.notify(res.message);
                this.setState({ addReportScheduleModel: false , isEdit: false, selectedFrequency: '', selectedReportParams: [], isEnable: false});
                this.getScheduleList()
            })
            .catch(err => {
                Notify.notify('Error While Creating Report Schedule');
            });
    };

    updateReportScheduling = () => {
       if (this.state.selectedReportParams.length <= 0) {
          Notify.notify('Please Select Report Parameteres.')
          return
       }
       if (this.state.selectedFrequency == '') {
          Notify.notify('Please Select Frequency.')
          return
       }

       const params = {
        userId : this.props.app.userId,
        email:this.state.loggedInUser?.emailid,
        frequency: this.state.selectedFrequency,
        enabled: this.state.isEnable,
        status: 'IDLE',
        timezone: 'Asia/Kolkata',
        parameterJson: this.state.selectedReportParams.join(',')
       }

        return Fetcher.post(this.props.app.apiPath + '/api/obd/report/schedule/' + this.state.scheduleId, { headers: { "Content-type": "application/json" }, method: 'PUT', body: JSON.stringify(params) })
            .then(res => {
                Notify.notify(res.message);
                this.setState({ addReportScheduleModel: false , isEdit: false, selectedFrequency: '', selectedReportParams: [], isEnable: false});
                this.getScheduleList()
            })
            .catch(err => {
                Notify.notify('Error While Updating Report Schedule');
            });
    };

    viewLogs = (row) => {
        window.location.href =
        `${this.props.app.urlPrefix}/report-scheduling-logs/${row.id}`;
    };

    editButtonClick = (row) => {
        this.setState({selectedFrequency: row.frequency , selectedReportParams: row.parameterJson.replace(/"/g, '').split(','), isEnable: row.enabled, scheduleId: row.id})
        this.getReportParameters()
        this.setState({ addReportScheduleModel: true, isEdit : true });
    };


    render() {
        const reportScheduleList = this.state.reportScheduleList;
        const columns = [
            {
                dataField: 'id',
                text: 'Id',
                sort: true,
                hidden: true
            },
            {
                dataField: 'frequency',
                text: 'Frequency',
                sort: true,
                hidden: false
            },
            {
                dataField: 'userId',
                text: 'User Id',
                sort: false,
                hidden: !this.props.app.isSubOrSuperAdmin,
            },
            {
                dataField: 'username',
                text: 'User Name',
                sort: false,
                hidden: !this.props.app.isSubOrSuperAdmin,
            },
            {
                dataField: 'status',
                text: 'Status',
                sort: false,
                hidden: false
            },
            {
                dataField: 'timezone',
                text: 'Timezone',
                sort: false,
                hidden: false
            },
            {
                dataField: 'parameterJson',
                text: 'Parameter Json',
                sort: false,
                hidden: false
            },
            {
                dataField: 'enabled',
                text: 'Enabled',
                sort: false,
                hidden: false
            },
            {
                dataField: 'createdAt',
                text: 'Created At',
                sort: false,
                hidden: false
            },
            {
                dataField: 'updatedAt',
                text: 'Updated At',
                sort: false,
                hidden: false
            },
            {
                dataField: 'nextRunAt',
                text: 'NextRun At',
                sort: false,
                hidden: false
            },
            {
                dataField: 'logs',
                text: 'Logs',
                sort: false,
                hidden: false,
                formatter: (cell, row) => {
                    return (
                        <Button
                            size="sm"
                            variant="success"
                            onClick={() => {
                                window.location.href = `${this.props.app.urlPrefix}/report-scheduling-logs/${row.id}`;
                            }}
                        >
                            View
                        </Button>
                    );
                }

            }
            ,
            {
                dataField: 'action',
                text: 'Action',
                sort: false,
                hidden: this.props.app.isSubOrSuperAdmin,
            },
        ];

        const records = Array.isArray(reportScheduleList) ? reportScheduleList.map((row, index) => {
            let action = [];
            const id = row.id;
            action.push(<Dropdown key={`${index}-dropdown`}>
                <Dropdown.Toggle className="btn-sm" variant="primary">Take Action</Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item key={`${index}-edit-user`} onClick={() =>  this.editButtonClick(row)}>Edit</Dropdown.Item>
                    <Dropdown.Item key={`${index}-delete-user`} href="#">Delete</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>);
            return {
                id: row.id,
                frequency: row.frequency,
                status: row.status,
                timezone: row.timezone,
                enabled: row.enabled,
                parameterJson: row.parameterJson,
                createdAt: row.createdAt,
                updatedAt: row.updatedAt,
                nextRunAt: row.nextRunAt,
                action: action,
                userId: row.userId,
                username: row.username ?? ""
            };
        }) : []

        const { SearchBar, ClearSearchButton } = Search;

        const defaultSorted = [{
            dataField: 'reqDate',
            order: 'desc'
        }];

        const paginationOption = {
            custom: true,
            totalSize: records.length,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: [10, 25, 50, 100],
            onSizePerPageChange: this.handleSizePerPageChange
        };

        return (
            <>
            <Card>
                <Card.Header>Report Scheduling</Card.Header>
                <Card.Body>
                    <div className="widget-list-table-cont">
                        <br/>

                        <PaginationProvider pagination={paginationFactory(paginationOption)}>
                            {({
                                paginationProps, paginationTableProps
                            }) => (
                                <ToolkitProvider
                                    keyField="reqDate"
                                    data={records}
                                    columns={columns}
                                    search
                                    bootstrap4
                                >
                                    {
                                        props => (
                                            <div className="">
                                                Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
                                                <span className="search-cont"><SearchBar {...props.searchProps} /></span>
                                                <ClearSearchButton className="btn-primary btn-round" {...props.searchProps} />
                                                {!this.props.app.isSubOrSuperAdmin && <Button id="addReportSchedule" type="button" className="float-right btn btn-default btn-primary ml-2" onClick={() => this.addReportSchedule()}>Create Report Scheduling</Button>}
                                                <Button id="refresh" type="button" className="float-right btn btn-default btn-primary ml-2" onClick={() => this.refreshPage()}>Refresh</Button>

                                                <hr />
                                                <BootstrapTable defaultSorted={defaultSorted} bordered={true} striped={true} condensed wrapperClasses="table-responsive" classes="widgetlist-table" {...props.baseProps} {...paginationTableProps} noDataIndication={"No data to show"} />
                                                <PaginationListStandalone {...paginationProps} />
                                            </div>
                                        )}
                                </ToolkitProvider>
                            )}
                        </PaginationProvider>
                    </div>

                    {(this.state.loading === true) && <div className="fetching-data"><img alt="" src="/assets/loading.gif" /></div>}
                </Card.Body>
            </Card>

			<Modal size="md" show={this.state.addReportScheduleModel} onHide={this.closeModal}>
				<Modal.Header closeButton>
			    	<Modal.Title id="example-modal-sizes-title-sm">
						Add Report Scheduling
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
							<Form method="post">
                                <Row>
                                <Col>
                                    <Form.Group className="form-group channels control-label">
                                    <Form.Label>Select Report Parameter</Form.Label>

                                    <Dropdown autoClose="outside">
                                        <Dropdown.Toggle variant="outline-secondary" className="w-100 text-start">
                                            {this.state.selectedReportParams.length
                                                ? `${this.state.selectedReportParams.length} parameter(s) selected`
                                                : 'Select report parameters'}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu className="w-100" style={{ maxHeight: '220px', overflowY: 'auto' }}>
                                            
                                            {/* Select All */}
                                            <Dropdown.Item as="div" className="px-3 border-bottom">
                                                <Form.Check
                                                    type="checkbox"
                                                    label="Select All"
                                                    checked={
                                                        this.state.selectedReportParams.length ===
                                                        this.state.reportParamsList.length
                                                    }
                                                    onChange={this.toggleSelectAll}
                                                />
                                            </Dropdown.Item>

                                            {/* Individual params */}
                                            {this.state.reportParamsList.map(item => (
                                                <Dropdown.Item as="div" key={item.paramName} className="px-3">
                                                    <Form.Check
                                                        type="checkbox"
                                                        label={item.paramHeading}
                                                        checked={this.state.selectedReportParams.includes(item.paramName)}
                                                        onChange={() => this.toggleParam(item.paramName)}
                                                    />
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>


                                    </Form.Group>
                                </Col>
                                </Row>


                                <Row>
                                    <Col md={this.state.isEdit ? 8 : 12}>
                                        <Form.Group className="form-group control-label">
                                        <Form.Label>Select Frequency</Form.Label>

                                        <Form.Select
                                            name="selectedFrequency"
                                            value={this.state.selectedFrequency}
                                            onChange={(e) =>
                                            this.setState({ selectedFrequency: e.target.value })
                                            }
                                        >
                                            <option value="">Select Frequency</option>
                                            <option value="HOURLY">Hourly</option>
                                            <option value="DAILY">Day Wise</option>
                                            <option value="WEEKLY">Weekly</option>
                                            <option value="MONTHLY">Monthly</option>
                                        </Form.Select>

                                        </Form.Group>
                                    </Col>
                                    {this.state.isEdit && (
                                        <Col md={4} className="d-flex align-items-center">
                                            <Form.Group className="form-group mb-0">
                                                <Form.Check
                                                    type="checkbox"
                                                    label="Enable"
                                                    checked={this.state.isEnable}
                                                    onChange={(e) =>
                                                        this.setState({ isEnable: e.target.checked })
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                    )}
                                </Row>

							</Form>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={this.closeModal} variant="secondary">CANCEL</Button>
					<Button
                        variant="primary"
                        type="button"
                        onClick={() =>
                            this.state.isEdit
                                ? this.updateReportScheduling()
                                : this.createReportScheduling()
                        }
                    >
                        Submit
                    </Button>

				</Modal.Footer>
			</Modal>
        </>

        );
    }
}

export default ReportScheduling;